"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = require("react");
var types_1 = require("./types");
var PAGES_BREAKDOWN_BREAKPOINT = 7;
var getPages = function (limit, activePage) {
    if (limit < PAGES_BREAKDOWN_BREAKPOINT) {
        return Array.from(Array(limit + 1).keys())
            .slice(1)
            .map(function (pageNumber) { return ({ value: pageNumber, type: types_1.PAGE_TYPE.NUMBER }); });
    }
    if ([1, 2, 3].includes(activePage)) {
        return [
            {
                value: 1,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: 2,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: 3,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: 4,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: 5,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: 6,
                type: types_1.PAGE_TYPE.DOTS
            },
            {
                value: limit,
                type: types_1.PAGE_TYPE.NUMBER
            }
        ];
    }
    if ([limit, limit - 1, limit - 2].includes(activePage)) {
        return [
            {
                value: 1,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: limit - 5,
                type: types_1.PAGE_TYPE.DOTS
            },
            {
                value: limit - 4,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: limit - 3,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: limit - 2,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: limit - 1,
                type: types_1.PAGE_TYPE.NUMBER
            },
            {
                value: limit,
                type: types_1.PAGE_TYPE.NUMBER
            }
        ];
    }
    return [
        {
            value: 1,
            type: types_1.PAGE_TYPE.NUMBER
        },
        {
            value: activePage - 2,
            type: types_1.PAGE_TYPE.DOTS
        },
        {
            value: activePage - 1,
            type: types_1.PAGE_TYPE.NUMBER
        },
        {
            value: activePage,
            type: types_1.PAGE_TYPE.NUMBER
        },
        {
            value: activePage + 1,
            type: types_1.PAGE_TYPE.NUMBER
        },
        {
            value: activePage + 2,
            type: types_1.PAGE_TYPE.DOTS
        },
        {
            value: limit,
            type: types_1.PAGE_TYPE.NUMBER
        }
    ];
};
var DEFAULT_LOCALES = {
    pageInputLabel: 'Page',
    countText: function (_a) {
        var from = _a.from, to = _a.to, total = _a.total;
        return from + " - " + to + " of " + total;
    }
};
var useLocales = function (locales) {
    return react_1.useMemo(function () {
        if (!locales) {
            return DEFAULT_LOCALES;
        }
        return tslib_1.__assign(tslib_1.__assign({}, DEFAULT_LOCALES), locales);
    }, [locales]);
};
exports["default"] = { getPages: getPages, useLocales: useLocales };
//# sourceMappingURL=PaginationHelper.js.map